module.exports = __webpack_public_path__ + "static/media/logo.b159454d.svg";